import React from 'react';
import { useTranslation } from 'react-i18next';
import { Slider } from '@fragments';
import { IconBorderRadius, IconBorderStyle2 } from '@tabler/icons-react';
import ColorField, { ColorPicker } from '../../ColorPicker';
import { PopoverAction } from '../controls';

// Fill (a color with its opacity, a gradient, or a photo masked by the shape), stroke and
// corner rounding. A line has no fill: its color is its stroke's.
export default function ShapeSection({ layer, update, colors, photo }) {
  const { t } = useTranslation('artEditor');
  const line = layer.shape === 'line';
  const stroke = layer.stroke;
  const key = name => ({ key: `${layer.id}:${name}` });
  return <>
    {!line && <ColorField label={t('fill')} value={layer.fill} modes={['solid', 'gradient', 'image']} alpha allowNone brand={colors.brand} used={colors.used} image={photo}
      onChange={fill => update({ fill }, key('fill'))} />}
    {line && <ColorField label={t('lineColor')} value={stroke?.color} brand={colors.brand} used={colors.used} onChange={color => update({ stroke: { ...stroke, color } }, key('stroke'))} />}
    <PopoverAction icon={IconBorderStyle2} label={t(line ? 'lineWidth' : 'stroke')} width={288}>
      {!line && <ColorPicker value={stroke?.color || null} allowNone brand={colors.brand} used={colors.used}
        onChange={color => update({ stroke: color ? { color, width: stroke?.width || 6 } : null }, key('stroke'))} />}
      {(line || stroke) && <Slider label={t(line ? 'lineWidth' : 'strokeWidth')} min={1} max={line ? 80 : 60} value={stroke?.width || 1}
        onChange={(_, width) => update({ stroke: { ...stroke, width } }, key('stroke'))} />}
    </PopoverAction>
    {layer.shape === 'rect' && <PopoverAction icon={IconBorderRadius} label={t('cornerRadius')}>
      <Slider label={t('cornerRadius')} min={0} max={Math.round(Math.min(layer.width, layer.height) / 2)} value={Math.min(layer.corner_radius, Math.round(Math.min(layer.width, layer.height) / 2))}
        onChange={(_, value) => update({ corner_radius: value }, key('corner_radius'))} />
    </PopoverAction>}
  </>;
}
